export default "__VITE_ASSET__uj$IyZP5__"